import React, { Component } from "react";
import classes from "./Dates.module.css";
import { connect } from "react-redux";
import axios from "axios";

import emailjs from "emailjs-com";

import {
  resetTotalMoney,
  resetTotalTime,
  changeMaster,
  changeChoosenItems,
  setTotalMasterList,
  phonesSetTotal,
  setModalWindow,
  setModalWindowContent,
} from "../../../store/actions/actions";

import Select from "../../../components/Select/Select";
import Calendar from "../../../components/Calendar/Calendar";

import "./Phone.css";
import MUIPhoneNumber from "material-ui-phone-number";

import {
  addWorkingDay,
  recordToDataBase,
  dateFinder,
} from "../../../funcs/funcs";
import { omit } from "lodash";

import { API_URL } from "../../../utils/api";

class Dates extends Component {
  state = {
    calendarValue: new Date(),
    choosenDay: null,
    buttons: null,
    userName: "",
    isUserNameCorrect: false,
    userPhone: "",
    isUserNamePhoneCorrect: false,
    selectedTime: "",
    indexDay: null,
    itemsForEmail: "",
  };

  componentDidUpdate(prevProps) {
    let index;

    if (this.state.choosenDay) {
      index = dateFinder(
        this.state.choosenDay,
        this.props.masterList[this.props.master][3]
      );
    }

    const actual =
      this.props.masterList[this.props.master][3][
        Object.keys(this.props.masterList[this.props.master][3])[index]
      ];

    const prev =
      prevProps.masterList[prevProps.master][3][
        Object.keys(prevProps.masterList[prevProps.master][3])[index]
      ];

    // Проверяем изменения БД
    // Если они были в выбранный пользователем день -
    // сбрасываем пользователю выбранное время
    if (JSON.stringify(actual) !== JSON.stringify(prev)) {
      // Генерируем клик по активному дню
      // document.querySelector(".react-calendar__tile--active").click();

      // Сбрасываем выбранное время
      // this.setState({
      //   selectedTime: "",
      // });

      // Переадресовуем пользователя в начало
      // чтоб заново выбрал услугу и время
      window.location.href = '/';
    }
  }

  async componentDidMount() {
    //прокручиваем страницу ВВЕРХ
    window.scrollTo(0, 0);

    //генерируем клик по активному дню, если это возможно
    document.querySelector(".react-calendar__tile--active").click();

    //скачиваем базу телефонов
    try {
      const response = await axios.get(`${API_URL}/phones.json`);

      //записываем в редакс
      this.props.phonesSetTotal(
        response.data[
          Object.keys(response.data)[Object.keys(response.data).length - 1]
        ]
      );

      //удаляем лишние записи
      for (let i = 0; i < Object.keys(response.data).length - 1; i++) {
        await axios.delete(
          `${API_URL}/phones/${Object.keys(response.data)[i]}.json`
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  dateChangeHandler = (date) => {
    let choosenDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    //получаем индекс выбранного дня вне зависимости от часового пояса
    const indexDay = dateFinder(
      choosenDay,
      this.props.masterList[this.props.master][3]
    );

    choosenDay = Object.keys(this.props.masterList[this.props.master][3])[
      indexDay
    ];

    //проверяем, существует ли данный день в БД
    //если не существует - добавляем
    if (indexDay === -1) {
      choosenDay = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );

      //клонируем состояние
      const clone = this.props.masterList.slice();

      addWorkingDay(clone[this.props.master][3], choosenDay);

      //записываем данные в Редакс
      this.props.setTotalMasterList(clone);
    }

    //устанавливаем локальное состояние
    this.setState({
      calendarValue: date,
      choosenDay,
    });

    //подсчет нужного числа ячеек, согласно общему времени услуг
    const userTime = Math.ceil(this.props.totalTime / 20);

    //перебираем дни в БД
    //удаляем прошедшие дни

    //массив для удаленных дней
    const toDelete = [];

    //перебираем дни из БД выбранного мастера
    Object.keys(this.props.masterList[this.props.master][3]).forEach((day) => {
      //получаем вчерашнюю дату
      //если оставим сегодня - в массив для удаления попадет и сегодняшний день

      //изменение - теперь оставляем архив на прошедшие 30 дней
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 30);

      //сравниваем каждый день объекта из БД с вчерашним днем
      //все лишнее добавляем в массив для удаления
      if (Date.parse(day) < yesterday.getTime()) {
        toDelete.push(day);
      }
    });

    //перебираем дни из БД выбранного мастера
    Object.keys(this.props.masterList[this.props.master][3]).forEach((day) => {
      toDelete.forEach((checkDay) => {
        //ищем совпадения в БД и списке для удаления
        if (day === checkDay) {
          //удаляем с помощью lodash
          this.props.masterList[this.props.master][3] = omit(
            this.props.masterList[this.props.master][3],
            day
          );
        }
      });
    });

    //массив-шаблон для времени, по которому строятся кнопки из выбранного дня
    const times = Object.keys(
      this.props.masterList[this.props.master][3][choosenDay]
    );

    //если не суббота - убираем лишнее
    if (date.getDay() < 6) {
      //клонируем состояние
      const clone = this.props.masterList.slice();

      clone[this.props.master][3][choosenDay]["07:20"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["07:40"].status = "NOT AVAILABLE";
      times.splice(0, 2);

      clone[this.props.master][3][choosenDay]["20:40"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["21:00"].status = "NOT AVAILABLE";
      times.splice(-2, 2);

      //записываем данные в Редакс
      this.props.setTotalMasterList(clone);
    }

    //если вторник или среда - убираем время для обедов
    if (date.getDay() === 2 || date.getDay() === 3) {
      //клонируем состояние
      const clone = this.props.masterList.slice();

      clone[this.props.master][3][choosenDay]["12:40"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["13:00"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["13:20"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["13:40"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["14:00"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["14:20"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["14:40"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["15:00"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["20:00"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["20:20"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["20:40"].status = "NOT AVAILABLE";
      clone[this.props.master][3][choosenDay]["21:00"].status = "NOT AVAILABLE";

      times.splice(-2, 2);

      //записываем данные в Редакс
      this.props.setTotalMasterList(clone);
    }

    // !!!!!!!!!!!! тут внизу исправление, раньше выбор времени был блоками
    // !!!!!!!!!!!! клиент захотел РУЛОН
    // !!!!!!!!!!!! больше ничего не разделяется

    //разделяем массив согласно нужному колчичеству ячеек
    let correctedArr = [];
    /*
    for (let i = 0; i < Math.ceil(times.length / userTime); i++) {
      correctedArr[i] = times.slice(i * userTime, i * userTime + userTime);
    }
    */

    for (let i = 0; i < Object.keys(times).length; i++) {
      correctedArr[i] = times[Object.keys(times)[i]];
    }

    //переменная, содержащая день из БД
    const thisDay = this.props.masterList[this.props.master][3][choosenDay];

    //массив для отображения кнопок
    const buttons = [];

    // убираем конец дня, когда услуга не влезает
    correctedArr = correctedArr.splice(0, correctedArr.length - userTime + 1);

    // eslint-disable-next-line
    correctedArr.map((item) => {
      // нужно обработать здесь конец дня
      // нужно сделать так, чтоб не выдавало занятые ячейки

      // убираем занятые ячейки
      if (thisDay[item].status !== "") {
        return null;
      }

      // получаем ВСЕ индексы свободных ячеек
      const index = Object.keys(thisDay).findIndex((index) => index === item);

      // отсеиваем ячейки, которые не подходят из-за занятости СЛЕДУЮЩИХ
      for (let i = 0; i < userTime; i++) {
        if (thisDay[Object.keys(thisDay)[+index + +i]].status !== "") {
          return null;
        }
      }
      buttons.push(item);
    });

    //проверка на СЕГОДНЯ

    //массив для записи отредактированного дня
    const corrButtons = [];

    const todayFull = new Date();
    const today = new Date(
      todayFull.getFullYear(),
      todayFull.getMonth(),
      todayFull.getDate()
    );

    const modifyChoosenDay = new Date(
      choosenDay.toString().split(" ").slice(0, 4)
    );

    //создаем текстовые переменные СЕГОДНЯ и ВЫБРАННОГО ДНЯ
    const textToday = `${today.getFullYear()}.${today.getMonth()}.${today.getDate()}`;
    const textChoosenDay = `${modifyChoosenDay.getFullYear()}.${modifyChoosenDay.getMonth()}.${modifyChoosenDay.getDate()}`;

    //сравниваем СЕГОДНЯ и ВЫБРАННЫЙ ДЕНЬ
    if (textToday === textChoosenDay) {
      buttons.forEach((item) => {
        const nowTest = new Date();
        const now = new Date();
        const hour = item.slice(0, 2);
        const min = item.slice(3);

        //если время еще в будущем - выводим пользователю
        if (now.setHours(hour, min) > nowTest.getTime()) {
          corrButtons.push(item);
        }
      });

      //записываем все строки из сегодняшнего дня в локальное состояние
      this.setState({
        buttons: corrButtons,
      });
    } else {
      //записываем все строки в локальное состояние, потому что это не сегодня
      this.setState({
        buttons,
      });
    }
  };

  selectTimehandler = (e) => {
    this.setState({
      selectedTime: e.target.value,
    });
  };

  //изменяем имя пользователя
  nameHandler = (e) => {
    e.preventDefault();
    const value = e.target.value;

    this.setState({
      userName: value,
    });

    //делаем валидацию имени
    let isValid = true;

    if (value.length <= 3) {
      isValid = false;
    }

    this.setState({
      isUserNameCorrect: isValid,
    });
  };

  //изменяем телефон пользователя
  phoneHandler = (value) => {
    this.setState({
      userPhone: value,
    });

    //делаем валидация телефона
    let isValid = true;

    if (value.length < 15) {
      isValid = false;
    }

    this.setState({
      isUserPhoneCorrect: isValid,
    });
  };

  submitHandler = async (e) => {
    e.persist();
    e.preventDefault();

    // определяем сколько минут пользователь выбирал бронь
    const time = (new Date() - this.props.startTime) / 60000;

    // если думал более 2 минут
    // вежливо просим выбрать время заново
    if (time < 2) {
      //переменная для вывода информации
      const recordInfo = [];

      //цикл, который создает полный перечень выбранных услуг для записи
      for (let j of this.props.choosenItems) {
        recordInfo.push(j.split(",")[0]);
      }

      //записываем выбранные услуги в состояние для отправки на почту
      this.setState({ itemsForEmail: recordInfo.join("; ") });

      //считаем нужное количество ячеек
      const userTime = Math.ceil(this.props.totalTime / 20);

      //считаем номер позиции первой ячейки для записи
      const startPlace = Object.keys(
        this.props.masterList[this.props.master][3][this.state.choosenDay]
      ).indexOf(this.state.selectedTime);

      //клонируем состояние
      const clone = this.props.masterList.slice();

      //цикл для записи во все нужные ячейки
      for (let i = startPlace; i < startPlace + userTime; i++) {
        const key = Object.keys(
          this.props.masterList[this.props.master][3][this.state.choosenDay]
        )[i];

        clone[this.props.master][3][this.state.choosenDay][key].status =
          recordInfo.join(", ");

        clone[this.props.master][3][this.state.choosenDay][key].name =
          this.state.userName.trim();

        clone[this.props.master][3][this.state.choosenDay][key].phone =
          this.state.userPhone;
      }

      const clonePhones = this.props.phones.slice();

      clonePhones.push(this.state.userPhone);

      //console.log(clonePhones);

      //записываем данные в Редакс
      this.props.setTotalMasterList(clone);

      //console.log("после записи ",this.props.masterList[this.props.master][3][this.state.choosenDay]);

      //показываем модальное окно
      this.props.setModalWindow(true);

      //запись заявки
      recordToDataBase(this.props.masterList);

      //запись в базу телефонов
      try {
        await axios.post(`${API_URL}/phones.json`, clonePhones);
        //console.log(response);
      } catch (error) {
        console.log(error);
      }

      //отправляем письмо на почту
      // ВРЕМЕННО ВЫКЛЮЧАЮ ПОЧТОВУЮ РАССЫЛКУ

      if (this.state.userName[0] === "!" && this.state.userName[1] === "!") {
        console.log("admin reserve!");
      } else {
        try {
          await emailjs.sendForm(
            "service_7o7p2er",
            "template_beazhyx",
            e.target,
            "user_qpcryx2AEsgbLFDfV7eR0"
          );
          //console.log(sentEmail);
        } catch (error) {
          console.log(error);
        }
      }

      //переадресовуем пользователя на лэндинг
      setTimeout(() => {
        //this.props.resetTotalMoney();
        //this.props.resetTotalTime();
        //this.props.changeMaster(0);
        //this.props.changeChoosenItems(new Set());
        //this.props.setModalWindow(false);
        window.location.href = "https://wonderful-barbershop.web.app/";
      }, 6000);
    } else {
      //изменяем текст модалки для опоздавшего пользователя
      this.props.setModalWindowContent("too_late");

      //показываем модальное окно
      this.props.setModalWindow(true);

      //переадресовуем пользователя в начало
      setTimeout(() => {
        window.location.href = "https://wonderful-barbershop-reserve.web.app/";
      }, 3000);
    }
  };

  render() {
    const now = new Date();
    const maxDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 30
    );

    const reserveBlock = (
      <>
        <div className={classes.Dates_offers_form}>
          <form onSubmit={(e) => this.submitHandler(e)}>
            <div>
              <p className={classes.Dates_offers_form_txt_first}>
                Scegli l'ora
              </p>
              <Select
                onChange={this.selectTimehandler}
                value={this.state.selectedTime}
                options={this.state.buttons}
              />
            </div>
            <div>
              <p className={classes.Dates_offers_form_txt}>Come ti chiami?</p>
              <input
                className={classes.Dates_offers_form_name}
                onChange={(e) => this.nameHandler(e)}
                value={this.state.userName}
                required
              ></input>
            </div>

            <div>
              <p className={classes.Dates_offers_form_txt}>
                Numero di telefono
              </p>
              <MUIPhoneNumber
                onlyCountries={["it"]}
                className="Phone_input"
                variant="outlined"
                defaultCountry={"it"}
                onChange={this.phoneHandler}
                regions={"europe"}
              />
            </div>

            <div className={classes.Dates_offers_form_send_block}>
              <input
                type="submit"
                className={classes.Dates_offers_form_send}
                disabled={
                  !this.state.isUserNameCorrect ||
                  !this.state.isUserPhoneCorrect ||
                  !this.state.selectedTime
                }
                value="prenotare"
              />
              {this.state.choosenDay ? (
                <input
                  readOnly
                  style={{ display: "none" }}
                  type="text"
                  name="message"
                  value={`Nome del cliente: ${this.state.userName.trim()}, numero di telefono: ${
                    this.state.userPhone
                  }, data: ${this.state.calendarValue.getDate()}.${
                    this.state.calendarValue.getMonth() + 1
                  }.${this.state.calendarValue.getFullYear()}, tempo: ${
                    this.state.selectedTime
                  }. Barbiere: ${
                    this.props.masterList[this.props.master][0]
                  }. (${this.state.itemsForEmail})`}
                />
              ) : null}
            </div>
          </form>
        </div>
      </>
    );

    return (
      <div className={classes.Dates}>
        <div className={classes.Dates_number}>
          <div className={classes.Dates_number_yellow}>
            <p>2</p>
          </div>
          <div className={classes.Dates_number_white}>
            <p>
              <span>passo </span>
              Scegli giorno
            </p>
          </div>
        </div>
        <div className={classes.Dates_calendar}>
          <Calendar
            minDate={now}
            maxDate={maxDate}
            value={this.state.calendarValue}
            onChange={this.dateChangeHandler}
          />
        </div>
        <div className={classes.Dates_offers}>
          {this.state.buttons ? reserveBlock : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    totalMoney: state.totalMoney,
    totalTime: state.totalTime,
    choosenItems: state.choosenItems,
    master: state.master,
    masterList: state.masterList,
    phones: state.phones,
    startTime: state.startTime,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetTotalMoney: () => dispatch(resetTotalMoney()),
    resetTotalTime: () => dispatch(resetTotalTime()),
    changeMaster: (num) => dispatch(changeMaster(num)),
    changeChoosenItems: (item) => dispatch(changeChoosenItems(item)),
    setTotalMasterList: (arr) => dispatch(setTotalMasterList(arr)),
    phonesSetTotal: (arr) => dispatch(phonesSetTotal(arr)),
    setModalWindow: (bool) => dispatch(setModalWindow(bool)),
    setModalWindowContent: (txt) => dispatch(setModalWindowContent(txt)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dates);
